import type { ReactNode } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { getAssistantMotionTransition } from './assistantMotion';

type AssistantAnimatedIconProps = {
  icon: ReactNode;
  iconKey: string;
  className?: string;
};

export function AssistantAnimatedIcon({
  icon,
  iconKey,
  className,
}: AssistantAnimatedIconProps) {
  const reducedMotion = Boolean(useReducedMotion());

  if (reducedMotion) {
    return (
      <span aria-hidden="true" className={className}>
        {icon}
      </span>
    );
  }

  return (
    <span aria-hidden="true" className={className}>
      <AnimatePresence initial={false}>
        <motion.span
          key={iconKey}
          initial={{ opacity: 0, scale: 0.82, rotate: -16, y: 2 }}
          animate={{ opacity: 1, scale: 1, rotate: 0, y: 0 }}
          exit={{ opacity: 0, scale: 0.82, rotate: 16, y: -2 }}
          transition={getAssistantMotionTransition('micro')}
          className="inline-flex items-center justify-center"
        >
          {icon}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
